import clsx from "clsx";
import React from "react";

type NumberInputProps = {
  id: string;
  value?: number;
  onChange?: (value: number) => void;
  onNativeChange?: React.EventHandler<React.ChangeEvent<HTMLInputElement>>;
  min: number;
  className?: string;
  placeholder?: string;
};

export const NumberInput = ({
  id,
  value,
  onChange,
  onNativeChange,
  min,
  className,
  placeholder,
}: NumberInputProps) => {
  return (
    <input
      id={id}
      type="number"
      value={value}
      onChange={(e) => {
        if (onChange) {
          onChange(parseInt(e.target.value, 10));
        }

        if (onNativeChange) {
          onNativeChange(e);
        }
      }}
      placeholder={placeholder}
      className={clsx(
        "inline-flex h-9 w-full flex-1 items-center justify-center rounded-md border-[1px] px-2 leading-normal text-gray-700",
        "border-gray-300 focus:border-gray-400",
        "bg-gray-50 focus:bg-white",
        "outline-none",
        "transition-all duration-200 ease-in-out",
        className,
      )}
      min={min}
    />
  );
};
